import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-error-pago',
  templateUrl: './error-pago.component.html',
  styleUrls: ['./error-pago.component.scss']
})
export class ErrorPagoComponent implements OnInit {

  no_autorizacion: string;
  referencia_pago: string;
  folio_recibo: string;

  telefonos = environment.telefonos;
  emails = environment.emails;
  enVentanaEmergente = !!window.opener;

  constructor(private route: ActivatedRoute, private router: Router) { }


  ngOnInit(): void {
  }


  Regresar() {
    // En ventana emergente se cierra; si se llego por redireccion completa, se vuelve al inicio.
    if (window.opener) {
      window.close();
      return;
    }
    this.router.navigate([""]);
  }

}
